/**
 * コース構成の単一の情報源。
 *
 *   第1〜20週  … 単語 2000 語（実コーパスの keyness 上位から順に配当）
 *   第21〜24週 … 句動詞・定型表現 400
 *
 * サーバ側の apps/server/src/lib/course.ts と値を揃えること。
 */
export const TOTAL_WEEKS = 24;
export const WORDS_PER_WEEK = 100;
export const WORD_WEEKS = 20;
export const TOTAL_ENTRIES = TOTAL_WEEKS * WORDS_PER_WEEK; // 2400

interface Tier {
  until: number;
  label: string;
  emoji: string;
  accent: string;
}

const TIERS: Tier[] = [
  { until: 4, label: "レビュー最頻出", emoji: "🌱", accent: "from-emerald-500 to-teal-400" },
  { until: 8, label: "頻出", emoji: "🌿", accent: "from-blue-500 to-cyan-400" },
  { until: 12, label: "実務コア", emoji: "🌳", accent: "from-indigo-500 to-violet-400" },
  { until: 16, label: "発展", emoji: "⚡", accent: "from-violet-500 to-fuchsia-400" },
  { until: WORD_WEEKS, label: "上級", emoji: "🚀", accent: "from-amber-500 to-orange-400" },
  { until: TOTAL_WEEKS, label: "句動詞・定型表現", emoji: "💬", accent: "from-pink-500 to-rose-400" },
];

export interface WeekMeta {
  title: string;
  subtitle: string;
  emoji: string;
  accent: string;
}

export function weekMeta(week: number): WeekMeta {
  const tier = TIERS.find((t) => week <= t.until) ?? TIERS[TIERS.length - 1];
  const unit = week > WORD_WEEKS ? "表現" : "語";
  return {
    title: `第${week}週`,
    subtitle: `${tier.label} ${WORDS_PER_WEEK}${unit}`,
    emoji: tier.emoji,
    accent: tier.accent,
  };
}

/** 旅マップの左右振り分け。4週ごとに中央を挟んで区切りを作る。 */
export function stageX(week: number): "left" | "center" | "right" {
  if (week % 4 === 0) return "center";
  return week % 2 === 1 ? "left" : "right";
}
